module.exports = __webpack_public_path__ + "static/media/HCMM728.bcf6bb9f.jpg";